// extracted by mini-css-extract-plugin
export default {"logo":"aVjVB24k_runzm6tn67GZ","large":"FDhABE_rqdsC3H14Fngeo","sub":"-JOX9J8HqV8odAqbWnVLh","small":"_2u0z8u8if_dKo_sfcXZL3q"};